//Picture Asset
import icon_type_text from "../../Assets/svg/icon_type_text.svg";
import icon_type_long from "../../Assets/svg/icon_type_long.svg";
import icon_type_number from "../../Assets/svg/icon_type_number.svg";
import icon_type_range from "../../Assets/svg/icon_type_range.svg";
import icon_type_phone from "../../Assets/svg/icon_type_phone.svg";
import icon_type_currency from "../../Assets/svg/icon_type_currency.svg";
import icon_type_year from "../../Assets/svg/icon_type_year.svg";
import icon_type_date from "../../Assets/svg/icon_type_date.svg";
import icon_type_time from "../../Assets/svg/icon_type_time.svg";
import icon_type_selection from "../../Assets/svg/icon_type_selection.svg";
import icon_type_radio from "../../Assets/svg/icon_type_radio.svg";
import icon_type_checklist from "../../Assets/svg/icon_type_checklist.svg";
import icon_type_image from "../../Assets/svg/icon_type_image.svg";
import icon_type_document from "../../Assets/svg/icon_type_document.svg";
import icon_type_link from "../../Assets/svg/icon_type_link.svg";
import icon_type_address from "../../Assets/svg/icon_type_address.svg";
import icon_type_address_poi from "../../Assets/svg/icon_type_address_poi.svg";
import icon_type_table from "../../Assets/svg/icon_type_table.svg";
import icon_type_counting from "../../Assets/svg/icon_type_counting.svg";
import icon_type_section from "../../Assets/svg/icon_type_section.svg";
import icon_type_calc from "../../Assets/svg/icon_type_calc.svg";
import icon_type_ref from "../../Assets/svg/icon_type_ref.svg";
import icon_type_ref_2d from "../../Assets/svg/icon_type_ref_2d.svg";
import icon_type_conditional from "../../Assets/svg/icon_type_conditional.svg";
import icon_type_provinsi from "../../Assets/svg/icon_type_provinsi.svg";
import icon_type_kota from "../../Assets/svg/icon_type_kota.svg";
import icon_type_kec from "../../Assets/svg/icon_type_kec.svg";
import icon_type_kel from "../../Assets/svg/icon_type_kel.svg";
import icon_type_id_data from "../../Assets/svg/icon_type_id_data.svg";
import icon_last_edit from "../../Assets/svg/icon_last_edit.svg";
import icon_edited_by from "../../Assets/svg/icon_edited_by.svg";
import icon_point from "../../Assets/svg/icon_point.svg";
import icon_type_rw from "../../Assets/svg/icon_type_rw.svg";
import icon_type_rt from "../../Assets/svg/icon_type_rt.svg";
import icon_type_template_literal from "../../Assets/svg/icon_type_template_literal.svg";

import { gometry_to_area_or_length } from "./geometry_to_area_or_length";
import { calculate_formula } from "./formula_validation";
import { calculate_conditional_statement } from "./conditional_statement_validation";

import dict from "../../Data/dict.json";
import calc_distance from "./calc_distance";
import { getChildrenFeaturesByColumnParentUuidAndRowParentUuid } from "../reduxHelper/layer";

import domain_list from "../../Data/domain_list";
import { get_country_code_and_phone_number } from "./phone_number";

/**
 * Keterangan:
 *
 * Function dengan return array dari berbagai macam tipe data seperti text, number, selection, year, date, checklist, dropdown, dll.
 * Kenapa nggak dibuat array langsung aja? kenapa harus berupa function? Ya, biar bisa pake bahasa dong...
 */
function data_types(language) {
  let array = [
    // --- Group: Most Used ---
    {
      name: dict["Text"][language],
      value: "text",
      ina: "Kolom teks standar untuk memasukkan kata, kalimat, atau karakter alfanumerik.",
      eng: "Standard text field for entering words, sentences, or alphanumeric characters.",
      icon: icon_type_text,
      type: "text",
      js_data_type: String,
      group: "Most Used",
      keywords: [
        "teks",
        "tulisan",
        "kata",
        "text",
        "input",
        "string",
        "kalimat",
        "sentence",
        "character",
        "char",
        "huruf",
        "nama",
        "name",
      ],
    },
    {
      name: dict["Number"][language],
      value: "number",
      ina: "Kolom input khusus untuk nilai numerik, mendukung bilangan bulat dan desimal.",
      eng: "Dedicated input field for numeric values, supporting both integers and decimals.",
      icon: icon_type_number,
      type: "number",
      js_data_type: Number,
      group: "Most Used",
      keywords: [
        "angka",
        "nomor",
        "bilangan",
        "number",
        "numeric",
        "integer",
        "desimal",
        "decimal",
        "float",
        "count",
        "quantity",
        "jumlah",
        "digit",
      ],
    },
    {
      name: dict["Selection"][language],
      value: "selection",
      ina: "Menu dropdown yang memungkinkan pengguna memilih satu opsi dari daftar yang tersedia.",
      eng: "A dropdown menu allowing the user to choose a single option from a provided list.",
      icon: icon_type_selection,
      type: "selection",
      js_data_type: String,
      group: "Most Used",
      keywords: [
        "pilihan",
        "dropdown",
        "opsi",
        "selection",
        "options",
        "menu",
        "list",
        "select",
        "pick",
        "choose",
      ],
    },
    {
      name: dict["Single Answer Button"][language],
      value: "radio_button",
      ina: "Tampilan tombol radio yang menampilkan semua opsi agar pengguna memilih satu jawaban tunggal.",
      eng: "Radio button display showing all options for the user to select a single answer.",
      icon: icon_type_radio,
      type: "selection",
      js_data_type: String,
      group: "Most Used",
      keywords: [
        "pilihan tunggal",
        "radio",
        "satu jawaban",
        "radio button",
        "single choice",
        "single answer",
        "option group",
        "bulatan",
      ],
    },
    {
      name: dict["Multi-Answer Checklist"][language],
      value: "checklist",
      ina: "Daftar centang yang memungkinkan pengguna memilih beberapa opsi sekaligus.",
      eng: "A checklist interface allowing users to select multiple options simultaneously.",
      icon: icon_type_checklist,
      type: "selection",
      js_data_type: String,
      callback: (data) => {
        const data_array = data?.split("\n");
        return String(data_array.join(", "));
      },
      group: "Most Used",
      keywords: [
        "pilihan ganda",
        "checkbox",
        "banyak pilihan",
        "checklist",
        "multiple choice",
        "multi select",
        "centang",
        "tick",
        "daftar",
      ],
    },
    {
      name: dict["Image"][language],
      value: "image",
      ina: "Fitur untuk mengambil foto langsung melalui kamera atau mengunggah file gambar.",
      eng: "Feature to capture photos directly via camera or upload image files.",
      icon: icon_type_image,
      type: "file",
      js_data_type: String,
      group: "Most Used",
      keywords: [
        "gambar",
        "foto",
        "citra",
        "image",
        "photo",
        "picture",
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "svg",
        "webp",
        "camera",
        "kamera",
        "upload",
        "gallery",
        "galeri",
      ],
    },
    {
      name: dict["Nested Table"][language],
      value: "table",
      ina: "Tabel di dalam formulir untuk memasukkan data yang lebih detail dan terstruktur.",
      eng: "A table within the form for entering detailed and structured data.",
      icon: icon_type_table,
      type: "other",
      js_data_type: String,
      group: "Most Used",
      keywords: [
        "tabel",
        "tabel bersarang",
        "subtabel",
        "table",
        "nested table",
        "subtable",
        "grid",
        "row",
        "column",
        "baris",
        "kolom",
        "matrix",
        "list",
      ],
    },

    // --- Group: Number ---
    {
      name: dict["Number with range"][language],
      value: "range",
      ina: "Penggeser untuk memilih nilai angka dalam batasan minimum dan maksimum tertentu.",
      eng: "A slider to select a numeric value within specific minimum and maximum limits.",
      icon: icon_type_range,
      type: "number",
      js_data_type: Number,
      group: "Number",
      keywords: [
        "rentang",
        "slider",
        "jangkauan",
        "range",
        "scale",
        "min",
        "max",
        "minimum",
        "maximum",
        "batas",
        "limit",
      ],
    },
    {
      name: dict["Phone Number"][language],
      value: "phone_number",
      ina: "Kolom format khusus untuk memasukkan nomor telepon dengan kode negara.",
      eng: "Specially formatted field for entering telephone numbers with country codes.",
      icon: icon_type_phone,
      type: "number",
      js_data_type: String,
      callback: (data) => {
        const { phoneNumber = "", countryCode } =
          get_country_code_and_phone_number(data);
        const data_array = `(+${countryCode}) ${phoneNumber}`;
        return String(data_array);
      },
      group: "Number",
      keywords: [
        "telepon",
        "nomor hp",
        "kontak",
        "phone",
        "mobile",
        "contact",
        "whatsapp",
        "wa",
        "call",
        "telp",
        "handphone",
        "cellphone",
      ],
    },
    {
      name: dict["Currency"][language],
      value: "currency",
      ina: "Kolom input numerik yang secara otomatis memformat nilai menjadi mata uang.",
      eng: "Numeric input field that automatically formats values into currency.",
      icon: icon_type_currency,
      type: "number",
      js_data_type: Number,
      group: "Number",
      keywords: [
        "mata uang",
        "uang",
        "harga",
        "currency",
        "money",
        "price",
        "rp",
        "rupiah",
        "idr",
        "dollar",
        "usd",
        "biaya",
        "cost",
        "nilai",
      ],
    },

    // --- Group: Date & Time ---
    {
      name: dict["Year"][language],
      value: "year",
      ina: "Pemilih sederhana untuk menentukan tahun tertentu tanpa tanggal atau bulan.",
      eng: "Simple selector to determine a specific year without date or month.",
      icon: icon_type_year,
      type: "time",
      js_data_type: Number,
      group: "Date & Time",
      keywords: ["tahun", "tahunan", "year", "annual", "yyyy", "yr", "periode"],
    },
    {
      name: dict["Date"][language],
      value: "date",
      ina: "Kalender pop-up untuk memilih tanggal, bulan, dan tahun secara lengkap.",
      eng: "Pop-up calendar for selecting a complete date, month, and year.",
      icon: icon_type_date,
      type: "time",
      js_data_type: Date,
      format_date: "dd-MM-yyyy",
      callback: (data) => {
        return new Date(data);
      },
      group: "Date & Time",
      keywords: [
        "tanggal",
        "hari",
        "kalender",
        "date",
        "calendar",
        "day",
        "bulan",
        "month",
        "schedule",
        "jadwal",
        "dd-mm-yyyy",
      ],
    },
    {
      name: dict["Time"][language],
      value: "time",
      ina: "Pemilih waktu untuk menentukan jam dan menit secara spesifik.",
      eng: "Time picker to specify hours and minutes accurately.",
      icon: icon_type_time,
      type: "time",
      js_data_type: String,
      group: "Date & Time",
      keywords: [
        "waktu",
        "jam",
        "pukul",
        "time",
        "hour",
        "clock",
        "menit",
        "minute",
        "second",
        "detik",
        "watch",
      ],
    },

    // --- Group: Other ---
    {
      name: dict["Long description"][language],
      value: "textarea",
      ina: "Area teks luas yang cocok untuk penulisan paragraf panjang atau catatan detail.",
      eng: "Large text area suitable for writing long paragraphs or detailed notes.",
      icon: icon_type_long,
      type: "text",
      js_data_type: String,
      group: "Other",
      keywords: [
        "deskripsi",
        "paragraf",
        "keterangan panjang",
        "description",
        "paragraph",
        "long text",
        "catatan",
        "note",
        "essay",
        "komentar",
        "comment",
      ],
    },
    {
      name: dict["Document File"][language],
      value: "document",
      ina: "Kolom unggahan untuk melampirkan file dokumen seperti PDF, Word, atau Excel.",
      eng: "Upload field for attaching document files like PDF, Word, or Excel.",
      icon: icon_type_document,
      type: "file",
      js_data_type: String,
      group: "Other",
      keywords: [
        "dokumen",
        "file",
        "berkas",
        "document",
        "attachment",
        "lampiran",
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "txt",
        "csv",
        "upload",
      ],
    },
    {
      name: dict["Link"][language],
      value: "link",
      ina: "Kolom input untuk menyimpan alamat URL situs web atau tautan eksternal.",
      eng: "Input field for storing website URLs or external links.",
      icon: icon_type_link,
      type: "other",
      js_data_type: String,
      group: "Other",
      keywords: [
        "tautan",
        "url",
        "link",
        "hyperlink",
        "website",
        "situs",
        "http",
        "https",
        "www",
        "web",
        "address",
      ],
    },
    {
      name: "Section",
      value: "section",
      ina: "Pemisah visual untuk mengelompokkan pertanyaan atau bagian formulir.",
      eng: "Visual divider to group questions or sections of the form.",
      icon: icon_type_section,
      type: "other",
      js_data_type: String,
      group: "Other",
      keywords: [
        "bagian",
        "pembagi",
        "grup",
        "section",
        "divider",
        "group",
        "separator",
        "header",
        "judul",
        "title",
      ],
    },
    {
      name: "Sheet",
      value: "sheet",
      ina: "Halaman kerja berbasis baris dan kolom untuk manajemen data yang kompleks.",
      eng: "Row and column-based worksheet for complex data management.",
      icon: icon_type_table,
      type: "sheet",
      js_data_type: String,
      group: "Other",
      keywords: [
        "lembar kerja",
        "sheet",
        "halaman",
        "worksheet",
        "spreadsheet",
        "page",
        "excel",
        "tab",
        "data sheet",
      ],
    },

    // --- Group: Auto Generate (Location) ---
    {
      name: dict["Urban Villages"][language],
      value: "kelurahan",
      ina: "Secara otomatis mengisi nama kelurahan atau desa berdasarkan lokasi titik.",
      eng: "Automatically fills in the urban village name based on the point location.",
      icon: icon_type_kel,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "kelurahan",
        "desa",
        "kampung",
        "village",
        "urban village",
        "subdistrict",
        "lurah",
        "admin",
        "region",
      ],
    },
    {
      name: dict["Regencies"][language],
      value: "kecamatan",
      ina: "Secara otomatis mengisi nama kecamatan berdasarkan lokasi titik.",
      eng: "Automatically fills in the sub-district name based on the point location.",
      icon: icon_type_kec,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "kecamatan",
        "distrik",
        "district",
        "regency",
        "subdistrict",
        "camat",
        "area",
        "admin",
      ],
    },
    {
      name: dict["Cities"][language],
      value: "kota",
      ina: "Secara otomatis mengisi nama kota atau kabupaten berdasarkan lokasi titik.",
      eng: "Automatically fills in the city or regency name based on the point location.",
      icon: icon_type_kota,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "kota",
        "kabupaten",
        "kotamadya",
        "city",
        "municipality",
        "regency",
        "bupati",
        "walikota",
        "pemkot",
        "pemkab",
      ],
    },
    {
      name: dict["Provinces"][language],
      value: "provinsi",
      ina: "Secara otomatis mengisi nama provinsi berdasarkan lokasi titik.",
      eng: "Automatically fills in the province name based on the point location.",
      icon: icon_type_provinsi,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "provinsi",
        "propinsi",
        "province",
        "state",
        "gubernur",
        "pemprov",
      ],
    },
    {
      name: dict["Auto Generate Street"][language],
      value: "auto_address",
      ina: "Membuat perkiraan alamat jalan lengkap berdasarkan koordinat lokasi.",
      eng: "Generates an estimated full street address based on location coordinates.",
      icon: icon_type_address,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "alamat",
        "jalan",
        "lokasi",
        "address",
        "street",
        "location",
        "road",
        "full address",
        "domisili",
      ],
    },
    {
      name: dict["Auto Generate POI"][language],
      value: "auto_address_poi",
      ina: "Mendeteksi nama tempat atau bangunan menarik terdekat dari lokasi.",
      eng: "Detects the name of the nearest place or point of interest from the location.",
      icon: icon_type_address_poi,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "tempat",
        "poi",
        "lokasi menarik",
        "point of interest",
        "place",
        "landmark",
        "gedung",
        "building",
        "venue",
      ],
    },
    {
      name: "Counting POI",
      value: "counting_poi",
      ina: "Menghitung jumlah titik lokasi tertentu dalam radius area yang ditentukan.",
      eng: "Counts the number of specific location points within a defined radius.",
      icon: icon_type_counting,
      type: "location",
      js_data_type: Number,
      group: "Auto Generate",
      keywords: [
        "hitung poi",
        "jumlah tempat",
        "counting",
        "count poi",
        "place count",
        "radius",
        "density",
        "kepadatan",
      ],
    },
    {
      name: "Custom Counting",
      value: "counting_custom",
      ina: "Melakukan perhitungan kustom berdasarkan parameter lokasi yang spesifik.",
      eng: "Performs custom calculations based on specific location parameters.",
      icon: icon_type_number,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "hitung kustom",
        "perhitungan",
        "custom count",
        "counting",
        "calculation",
        "algoritma",
        "algorithm",
      ],
    },

    // --- Group: Auto Generate (Formula) ---
    {
      name: dict["Calculate Dimension"][language],
      value: "calculate_dimension",
      ina: "Menghitung dimensi atau luas area berdasarkan data spasial.",
      eng: "Calculates dimensions or area size based on spatial data.",
      icon: icon_type_calc,
      type: "formula",
      js_data_type: Number,
      group: "Auto Generate",
      keywords: [
        "hitung dimensi",
        "ukuran",
        "luas",
        "dimension",
        "measurement",
        "calculate",
        "area",
        "size",
        "panjang",
        "length",
        "width",
        "lebar",
      ],
    },
    {
      name: dict["Simple Referring"][language],
      value: "simple_referring",
      ina: "Mengambil nilai tunggal dari sumber data lain yang terhubung.",
      eng: "Retrieves a single value from another connected data source.",
      icon: icon_type_ref,
      type: "formula",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "referensi",
        "rujukan",
        "acuan",
        "reference",
        "referring",
        "lookup",
        "source",
        "sumber",
        "connect",
      ],
    },
    {
      name: dict["2D Referring"][language],
      value: "2d_referring",
      ina: "Mengambil data berdasarkan referensi baris dan kolom (matriks).",
      eng: "Retrieves data based on row and column references (matrix).",
      icon: icon_type_ref_2d,
      type: "formula",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "referensi 2d",
        "rujukan tabel",
        "2d reference",
        "table lookup",
        "matrix reference",
        "vlookup",
        "hlookup",
      ],
    },
    {
      name: dict["Math Operators"][language],
      value: "math_operators",
      ina: "Menjalankan rumus matematika menggunakan nilai dari kolom lain.",
      eng: "Executes mathematical formulas using values from other fields.",
      icon: icon_type_number,
      type: "formula",
      js_data_type: Number,
      group: "Auto Generate",
      keywords: [
        "operasi matematika",
        "rumus",
        "kalkulasi",
        "math",
        "formula",
        "calculation",
        "tambah",
        "kurang",
        "kali",
        "bagi",
        "add",
        "subtract",
        "multiply",
        "divide",
      ],
    },
    {
      name: dict["Conditional Statement"][language],
      value: "conditional_statement",
      ina: "Menerapkan logika Jika/Maka untuk menghasilkan output dinamis.",
      eng: "Applies If/Then logic to generate dynamic output.",
      icon: icon_type_conditional,
      type: "formula",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "kondisi",
        "if then",
        "logika",
        "conditional",
        "logic",
        "if statement",
        "else",
        "syarat",
        "rule",
      ],
    },
    {
      name: dict["Table Formula"][language],
      value: "table_formula",
      ina: "Menerapkan rumus perhitungan khusus di dalam baris tabel.",
      eng: "Applies specific calculation formulas within table rows.",
      icon: icon_type_number,
      type: "formula",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "rumus tabel",
        "formula tabel",
        "table formula",
        "table calculation",
        "row calculation",
        "hitung baris",
      ],
    },

    // --- Group: Auto Generate (Other) ---
    {
      name: dict["User name"][language],
      value: "auto_generate_user_name",
      ina: "Otomatis mencatat nama akun pengguna yang sedang mengisi data.",
      eng: "Automatically records the account name of the user entering the data.",
      icon: icon_type_number,
      type: "other",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "nama pengguna",
        "user",
        "username",
        "user name",
        "account name",
        "akun",
        "profile",
        "profil",
      ],
    },
    {
      name: "ID Data",
      value: "id_data",
      ina: "Menghasilkan kode identifikasi unik untuk setiap entri data.",
      eng: "Generates a unique identification code for each data entry.",
      icon: icon_type_id_data,
      type: "other",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "id",
        "identitas",
        "pengenal",
        "identifier",
        "unique id",
        "data id",
        "uuid",
        "key",
        "kode",
        "code",
      ],
    },
    {
      name: dict["Last Edited"][language],
      value: "last_edited",
      ina: "Mencatat waktu dan tanggal terakhir kali data diubah.",
      eng: "Records the time and date when the data was last modified.",
      icon: icon_last_edit,
      type: "other",
      format_date: "dd-MM-yyyy HH:mm:ss",
      js_data_type: Date,
      callback: (data) => {
        return new Date(data);
      },
      group: "Auto Generate",
      keywords: [
        "terakhir diedit",
        "waktu edit",
        "timestamp",
        "last edited",
        "modified date",
        "update time",
        "updated at",
        "log",
      ],
    },
    {
      name: dict["Edited By"][language],
      value: "edited_by",
      ina: "Mencatat nama pengguna yang terakhir kali mengubah data.",
      eng: "Records the username who last modified the data.",
      icon: icon_edited_by,
      type: "other",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "diedit oleh",
        "editor",
        "pengubah",
        "edited by",
        "modifier",
        "last editor",
        "updated by",
      ],
    },
    {
      name: "Longitude",
      value: "longitude",
      ina: "Menampilkan koordinat garis bujur dari lokasi yang dipilih.",
      eng: "Displays the longitude coordinate of the selected location.",
      icon: icon_point,
      type: "other",
      js_data_type: Number,
      group: "Auto Generate",
      keywords: [
        "bujur",
        "longitude",
        "koordinat x",
        "longitude",
        "x coordinate",
        "lng",
        "long",
        "gps",
        "peta",
        "map",
      ],
    },
    {
      name: "Latitude",
      value: "latitude",
      ina: "Menampilkan koordinat garis lintang dari lokasi yang dipilih.",
      eng: "Displays the latitude coordinate of the selected location.",
      icon: icon_point,
      type: "other",
      js_data_type: Number,
      group: "Auto Generate",
      keywords: [
        "lintang",
        "latitude",
        "koordinat y",
        "latitude",
        "y coordinate",
        "lat",
        "gps",
        "peta",
        "map",
      ],
    },
  ];

  const domain = window.location.host;
  const is_domain_kai = domain_list?.[domain]?.is_domain_kai;

  // --- Conditional Additions (dsdajakarta domains) - Group: Auto Generate & Other ---
  if (
    [
      "localhost:3003",
      "dsdajakarta.mapid.io",
      "dsdajakarta-alpha.mapid.io",
      "dsdajakarta-beta.mapid.io",
    ].includes(domain)
  ) {
    array.push({
      name: "RT",
      value: "rt",
      ina: "Otomatis mendeteksi nomor RT berdasarkan lokasi.",
      eng: "Automatically detects the RT (neighborhood unit) number based on location.",
      icon: icon_type_rt,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: ["rt", "rukun tetangga", "neighborhood", "community unit"],
    });
    array.push({
      name: "RW",
      value: "rw",
      ina: "Otomatis mendeteksi nomor RW berdasarkan lokasi.",
      eng: "Automatically detects the RW (community unit) number based on location.",
      icon: icon_type_rw,
      type: "location",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "rw",
        "rukun warga",
        "community association",
        "citizen association",
      ],
    });
    array.push({
      name: "Template Literal",
      value: "template_literal",
      ina: "Membuat teks dinamis dengan menggabungkan nilai dari kolom lain.",
      eng: "Creates dynamic text by combining values from other fields.",
      icon: icon_type_template_literal,
      type: "other",
      js_data_type: String,
      group: "Auto Generate",
      keywords: [
        "template",
        "literal",
        "string dinamis",
        "template literal",
        "dynamic string",
        "formatted text",
        "gabung teks",
        "merge text",
      ],
    });
  }

  // --- Conditional Additions (KAI domain) - Group: Auto Generate & Other ---
  if (is_domain_kai) {
    array.push({
      name: "CAPEX",
      value: "capex_value",
      ina: "Kolom khusus untuk input nilai pengeluaran modal (Capital Expenditure).",
      eng: "Specific field for entering Capital Expenditure values.",
      icon: icon_type_number,
      type: "other",
      js_data_type: Number,
      group: "Auto Generate",
      keywords: [
        "capex",
        "modal",
        "investasi",
        "capital expenditure",
        "investment",
        "capital",
        "budget",
        "anggaran",
      ],
    });

    array.push({
      name: "Sheet Appraisal",
      value: "sheet_appraisal",
      ina: "Lembar kerja khusus untuk melakukan proses penilaian aset.",
      eng: "Dedicated worksheet for performing asset appraisal processes.",
      icon: icon_type_table,
      type: "sheet",
      js_data_type: String,
      group: "Other",
      keywords: [
        "penilaian",
        "appraisal",
        "valuasi",
        "appraisal sheet",
        "valuation",
        "assessment",
        "harga pasar",
        "market value",
      ],
    });

    array.push({
      name: "Sheet HBU",
      value: "sheet_hbu",
      ina: "Lembar analisis untuk menentukan penggunaan lahan tertinggi dan terbaik.",
      eng: "Analysis sheet to determine the Highest and Best Use of land.",
      icon: icon_type_table,
      type: "sheet",
      js_data_type: String,
      group: "Other",
      keywords: [
        "hbu",
        "penggunaan tertinggi",
        "analisis",
        "highest best use",
        "analysis",
        "optimal use",
        "lahan",
        "land",
      ],
    });

    array.push({
      name: "RAM Integration",
      value: "ram",
      ina: "Integrasi sistem manajemen aset rel (RAM) untuk sinkronisasi data.",
      eng: "Rail Asset Management (RAM) integration for data synchronization.",
      icon: icon_type_table,
      type: "other",
      js_data_type: String,
      group: "Other",
      keywords: [
        "ram",
        "integrasi",
        "koneksi",
        "integration",
        "connection",
        "link",
        "sync",
        "sinkronisasi",
      ],
    });
  }

  return array;
}
/**
 * Keterangan:
 *
 * list tipe data yang harus dikalkulasikan dulu sebelum ditampilkan
 */
const data_types_that_must_be_calculate_before_render = [
  "simple_referring",
  "calculate_dimension",
  "math_operators",
  "2d_referring",
  "conditional_statement",
  "nilai_pembanding",
  "jarak_apraisal",
  "summary_of_nested_table",
  "table_formula",
  "auto_generate_user_name",
  "capex_value",
  "id_data",
  "longitude",
  "latitude",
  "template_literal",
];

/**
 * Keterangan:
 *
 * Function ini digunakan untuk menghubungkan function (rumus/algoritma) dengan tipe data formula yang sesuai. Angka hasil kalkulasi akan masuk dalam feature.
 */
function calculate_by_data_type({
  feature,
  fields,
  layer_pembanding,
  feature_parent,
  feature_appraisal,
  source,
  capex_value,
}) {
  try {
    let properties = feature?.properties || {};

    feature.properties = properties;

    fields.forEach((field) => {
      if (field.type === "simple_referring") {
        const { reference_list, reference_key } = field;
        const properties = feature?.properties || {};
        const value = reference_list.find(
          (ref) =>
            String(ref?.name)?.toLowerCase()?.trim() ===
            String(properties?.[reference_key])?.toLowerCase()?.trim()
        )?.["value"];
        if (typeof value === "number") {
          feature.properties[field.key] = +value;
        } else {
          feature.properties[field.key] = value;
        }
      } else if (field.type === "capex_value") {
        feature.properties[field.key] = capex_value;
      } else if (field.type === "calculate_dimension") {
        const { geometry } = feature;
        const { value } = gometry_to_area_or_length(geometry, field.unit);
        const final_value = value;
        feature.properties[field.key] = final_value;
      } else if (field.type === "math_operators") {
        let value;
        // dikomen tanggal 6 desember 2024 (KAI), karna ketika data inputnya berubah, hasil math operators tidak berubah

        // const value_db = feature?.properties?.[field?.key];
        // if (value_db === undefined || value_db === "") {
        value = calculate_formula(field.formula, feature.properties);
        // } else {
        //   value = value_db;
        // }

        if (isNaN(value) || value === "" || value === undefined) {
          feature.properties[field.key] = 0;
        } else {
          feature.properties[field.key] = Number(value);
        }
      } else if (field.type === "2d_referring") {
        const index_row_name = field.reference_list_2d?.row_name;
        const index_column_name = field.reference_list_2d?.column_name;
        let value = "";
        if (feature?.properties?.[index_column_name]) {
          const selected_row = field.reference_list_2d?.features?.find(
            (row) =>
              String(row?.["index_name"])?.toLowerCase()?.trim() ===
              String(feature?.properties?.[index_row_name])
                ?.toLowerCase()
                ?.trim()
          );
          value = selected_row?.[feature.properties?.[index_column_name]];
          feature.properties[field.key] = value;
        }
      } else if (field.type === "conditional_statement") {
        const value = calculate_conditional_statement(
          field.conditional_statement_list,
          feature.properties
        );
        feature.properties[field.key] = value;
      } else if (field.type === "nilai_pembanding") {
        const feature_parent_final = feature_parent || feature;
        const data_pembanding_list =
          feature_parent_final?.data_pembanding_list || [];
        let fields = layer_pembanding?.fields || [];
        fields = fields.filter((item) => !item?.isStyle);
        let features = layer_pembanding?.geojson?.features || [];
        features = features.filter((item) =>
          data_pembanding_list.includes(item?.key)
        );
        //kolom nilai rev_calculation_field_key
        const rev_calculation_field_key =
          layer_pembanding?.rev_calculation_field_key;
        //kolom nilai percent_value_field_key
        const percent_value_field_key =
          layer_pembanding?.percent_value_field_key;
        const field_percent = fields.find(
          (item) => item.key === percent_value_field_key
        );
        let sum;
        if (field_percent?.key) {
          const array_of_number = features.map((item) =>
            Number(item.properties[percent_value_field_key])
          );
          const init = 0;
          sum = array_of_number.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            init
          );
        }
        features = features.map((item) => {
          const nilai_pembobotan =
            item?.properties?.[percent_value_field_key] / sum;
          const nilai_indikasi =
            item?.properties?.[rev_calculation_field_key] * nilai_pembobotan;
          item.properties.nilai_pembobotan = nilai_pembobotan;
          item.properties.nilai_indikasi = nilai_indikasi;
          return item;
        });
        let total_indikasi = 0;
        if (field_percent?.key) {
          const array_of_number = features.map((item) =>
            Number(item?.properties?.nilai_indikasi)
          );
          const init = 0;
          total_indikasi = array_of_number.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            init
          );
        }
        feature.properties[field.key] = parseInt(total_indikasi);
      } else if (field.type === "jarak_apraisal" && feature_appraisal) {
        let distance_in_meter = "?";
        const long_1 = feature?.geometry?.coordinates[0];
        const lat_1 = feature?.geometry?.coordinates[1];
        const long_2 = feature_appraisal?.geometry?.coordinates[0];
        const lat_2 = feature_appraisal?.geometry?.coordinates[1];
        if (long_1 && lat_1 && long_2 && lat_2) {
          distance_in_meter = (
            calc_distance(lat_1, long_1, lat_2, long_2) * 1000
          ).toFixed(0); //dikalikan 1000 untuk konversi kilometer menjadi meter
        }
        feature.properties[field.key] = distance_in_meter;
      } else if (field.type === "table_formula") {
        if (field?.table_formula) {
          const { field_parent_uuid, field_child_uuid, formula } =
            field?.table_formula;
          if (field_parent_uuid && field_child_uuid && formula) {
            const params = {
              feature: feature_parent || feature,
              column_parent_uuid: field_parent_uuid,
              row_parent_uuid: feature?.child_uuid,
            };
            const children =
              getChildrenFeaturesByColumnParentUuidAndRowParentUuid(params);

            if (children?.length > 0) {
              let summary = 0;
              if (formula === "sum") {
                children?.forEach((child) => {
                  let value_number = Number(
                    child?.properties?.[field_child_uuid]
                  );
                  if (isNaN(value_number)) value_number = 0;
                  summary += value_number;
                });
              } else if (formula === "avg") {
                children?.forEach((child) => {
                  let value_number = Number(
                    child?.properties?.[field_child_uuid]
                  );
                  if (isNaN(value_number)) value_number = 0;
                  summary += value_number;
                });
                summary /= children?.length;
              } else if (formula === "min") {
                const array_of_number = children.map((child) => {
                  let value_number = Number(
                    child?.properties?.[field_child_uuid]
                  );
                  if (isNaN(value_number)) value_number = 0;
                  return value_number;
                });
                summary = Math.min(...array_of_number);
              } else if (formula === "max") {
                const array_of_number = children.map((child) => {
                  let value_number = Number(
                    child?.properties?.[field_child_uuid]
                  );
                  if (isNaN(value_number)) value_number = 0;
                  return value_number;
                });
                summary = Math.max(...array_of_number);
              } else if (formula === "count") {
                summary = children?.length || 0;
              } else if (formula === "last_data") {
                summary = children?.at(-1)?.properties?.[field_child_uuid];
              }

              feature.properties[field.key] = summary;
            }
          }
        }
      } else if (field.type === "auto_generate_user_name") {
        feature.properties[field.key] = feature?.user?.full_name || "";
      } else if (field.type === "id_data") {
        feature.properties[field.key] = feature?._id;
      } else if (field.type === "last_edited") {
        feature.properties[field.key] = feature?.updated_at;
      } else if (field.type === "edited_by") {
        feature.properties[field.key] =
          feature?.updated_by?.name || feature?.updated_by;
      } else if (field.type === "longitude") {
        feature.properties[field.key] = feature?.geometry?.coordinates[0];
      } else if (field.type === "latitude") {
        feature.properties[field.key] = feature?.geometry?.coordinates[1];
      } else if (field.type === "template_literal") {
        const { reference_key, template_literal_text } = field;
        const value = feature?.properties?.[reference_key];
        feature.properties[field.key] = `${
          template_literal_text?.first || ""
        } ${value || "-"} ${template_literal_text?.last || ""}`;
      }
    });

    return feature;
  } catch (error) {}
}

export {
  data_types,
  data_types_that_must_be_calculate_before_render,
  calculate_by_data_type,
};
